import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { get, keys } from 'lib/utils/localStorage';
import trackSelectedSalon from 'lib/utils/trackSelectedSalon';
import { salonMatchesEmail } from 'lib/utils/salonsHelpers';
import useVisitorTypeTracking from 'hooks/tracking/useVisitorTypeTracking';
import Icon from 'components/shared/icon';
import { useSettings } from 'contexts';
import Logo from 'components/shared/logo';
import Head from 'next/head';
import {
  getLocaleByCountry,
  setStorageSelectedSalonNo,
  setStorageCustomerSalonName,
  setStorageCustomerSalonNo,
} from 'lib/shopify';
import { addLocaleToHref } from 'lib/utils/helpers';

const ReferrerPage = ({ kickbackFeeCode }) => {
  const router = useRouter();
  const { salons } = useSettings();
  const customerEmail = get(keys.LOGGED_IN_CUSTOMER);
  const { pageSlug, multi } = router.query;

  const fetchData = async () => {
    const response = await fetch(
      `/api/firebase/get-salon-by-kickback-fee-code?kickbackFeeCode=${encodeURIComponent(kickbackFeeCode)}`
    );
    const { data } = await response.json();

    const fetchedSalon = data.find(
      s =>
        (s.kickbackFeeCode &&
          s.kickbackFeeCode.toString().toLowerCase() === kickbackFeeCode.toLowerCase()) ||
        (s.salonNo && s.salonNo.toString() === kickbackFeeCode)
    );

    if (fetchedSalon && fetchedSalon.qualifiesForKickbackfee) {
      trackSelectedSalon({
        salonNo: fetchedSalon.salonNo,
        eventName: 'affiliation_salon',
        location: { action: router },
      });
      const hasLocaleAccess =
        fetchedSalon.kickbackFeeLocales?.includes(router.locale) || multi === 'true';
      const locale = hasLocaleAccess
        ? router.locale
        : getLocaleByCountry(fetchedSalon.country, fetchedSalon.ZipCode);
      setStorageCustomerSalonNo(locale, fetchedSalon.salonNo);
      setStorageCustomerSalonName(locale, fetchedSalon.salonName);
      setStorageSelectedSalonNo(locale, fetchedSalon.salonNo);
      const targetPath = addLocaleToHref(pageSlug || '/', locale, router);
      await router.push(
        `${targetPath}?fromKickbackFeeCode=${encodeURIComponent(fetchedSalon.salonName)}`
      );
    } else {
      await router.push(addLocaleToHref(pageSlug || '/', router.locale, router));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (customerEmail) {
      const fetchedSalons = salons.filter(s => salonMatchesEmail(s, customerEmail));
      if (fetchedSalons.length > 0) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useVisitorTypeTracking({
          visitorType: fetchedSalons[0].salonNo,
          location: { action: router },
        });
      }
      // eslint-disable-next-line react-hooks/rules-of-hooks
      else useVisitorTypeTracking({ visitorType: 'KEUNE Cosmetics', location: { action: router } });
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    else useVisitorTypeTracking({ visitorType: 'KEUNE Cosmetics', location: { action: router } });
  }, [router]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '3rem',
      }}
    >
      {/* Make kickbackfeeCode pages non-indexable by search engines */}
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <div
        style={{
          width: '10rem',
        }}
      >
        {' '}
        <Logo />
      </div>
      <Icon type="loading" />
    </div>
  );
};

export async function getServerSideProps({ params }) {
  const { kickbackFeeCode } = params;

  return {
    props: { kickbackFeeCode },
  };
}

export default ReferrerPage;
